import { AxiosRequestConfig } from "axios";
import { randomString } from "../utils/helper";

export default function defaultRequest(config: AxiosRequestConfig) {
  config!.headers!["X-CORRELATION-ID"] = `${randomString(8)}-${randomString(
    4
  )}-${randomString(2)}`;
  return config;
}
